import React, {Suspense} from 'react';
import { Link } from "react-router-dom";

import { ContentCardCategoriaInicio, ImagenCategoria, ContentNombreCategoriaInicio} from "./Estilos";

import SinFoto from "../../assets/Images/sin_foto.png";

const CardsCategorias = ({categoria}) => {
    return (
        <Suspense>
        <div className="col-md-2 col-4 mt-1 mb-1">
           
            <ContentCardCategoriaInicio>
                <Link to={`/Productos/ByCategoria/${categoria.IdentificacionSicoi}`} className='w-100'>
                    {
                        categoria.URLImagen === '' ?
                        <>  
                            <ImagenCategoria src={SinFoto} alt={`Rueda Digital Categoria ${categoria.Nombre}`} />
                        </>
                        :
                        <>
                            <ImagenCategoria src={`https://api.ruedadigital.com.ar/${categoria.URLImagen}`}  alt={`Rueda Digital Categoria ${categoria.Nombre}`} />
                        </>
                    }
                    <ContentNombreCategoriaInicio>
                        <p>{categoria.Nombre}</p>
                    </ContentNombreCategoriaInicio>


                </Link>
                
            </ContentCardCategoriaInicio>
          
        </div>
        </Suspense>
    );
}



export default CardsCategorias;